function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.28 0H0v40h16v-9.47h15.28c9.054 0 15.265-6.377 15.265-15.265C46.545 6.378 40.335 0 31.28 0z",
  fill: "#DDD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.28 0H0v19.198h31.28c9.053 0 15.265-1.865 15.265-3.933C46.545 6.378 40.335 0 31.28 0z",
  fill: "url(#playground-symbol_svg__playground-symbol_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "playground-symbol_svg__playground-symbol_svg__paint0_linear",
  x1: 46.667,
  y1: 15.333,
  x2: 0,
  y2: 15.333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DDD"
})));

function SvgPlaygroundSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0NyA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjI4IDBIMFY0MEgxNkwxNiAzMC41MzA5SDMxLjI4QzQwLjMzNDUgMzAuNTMwOSA0Ni41NDU1IDI0LjE1MjcgNDYuNTQ1NSAxNS4yNjU1QzQ2LjU0NTUgNi4zNzgxOCA0MC4zMzQ1IDAgMzEuMjggMFoiIGZpbGw9IiNEREREREQiLz4KPHBhdGggZD0iTTMxLjI4IDBIMEwwIDE5LjE5NzZIOC4zMzMzMkgzMS4yOEM0MC4zMzMzIDE5LjE5NzYgNDYuNTQ1NSAxNy4zMzMzIDQ2LjU0NTUgMTUuMjY1NUM0Ni41NDU1IDYuMzc4MTggNDAuMzM0NSAwIDMxLjI4IDBaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI0Ni42NjY3IiB5MT0iMTUuMzMzMyIgeDI9IjEuNzY1MjZlLTA3IiB5Mj0iMTUuMzMzMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNEREREREQiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgPlaygroundSymbol as ReactComponent };